import React, { useRef, useState } from "react"
import ReactHtmlParser from "react-html-parser"
import { accessibilityEnterCheck } from "../../helpers/accessibilityHelper"

function PracticalFaqElement(props) {
  const accordionRef = useRef(null)

  const [isAccordionOpen, setIsAccordionOpen] = useState(false)

  const handleAccordion = (event, classname) => {
    let elem = event.currentTarget

    let node = event
    if (elem) {
      showHideContent(elem, classname)
      return
    }

    if (node) {
      showHideContent(node, classname)
      return
    }
  }

  const handleEnterKeyPress = (event, className) => {
    accessibilityEnterCheck(event, () => {
      const targetElement = event.target.childNodes[0]
      handleAccordion(targetElement, className)
    })
  }

  const showHideContent = (elem, classname) => {
    elem.__toggle = !elem.__toggle
    let target = elem.parentElement.querySelector(classname)
    if (elem.__toggle) {
      target.style.height = target.scrollHeight + "px"
      elem.classList.add("is-active")
      setIsAccordionOpen(true)
    } else {
      target.style.height = 0 + "px"
      elem.classList.remove("is-active")
      setIsAccordionOpen(false)
    }
  }

  const question = props.question
  const answer = props.answer

  const transform = (node) => {
    if (node.type === "tag" && node.name === "a") {
      // Set tabindex to -1 if the accordion is closed, otherwise keep it as is
      const tabindexValue = isAccordionOpen ? 0 : -1
      node.attribs.tabindex = tabindexValue
    }
  }

  const formattedAnswer = ReactHtmlParser(answer, { transform })

  return (
    <div
      tabIndex={0}
      role="button"
      onKeyDown={(e) => handleEnterKeyPress(e, ".contentWrapper")}
      aria-expanded={isAccordionOpen}
      ref={accordionRef}
      className="accordionitem"
      id={question}
    >
      <h4 data-epi-property="Question" aria-controls={question} className="accordion-trigger" onClick={(e) => handleAccordion(e, ".contentWrapper")}>
        {question}
      </h4>
      <div className="sand-break">
        <div></div>
      </div>
      <div className="contentWrapper show-hide" role="region" aria-labelledby={question + "-label"}>
        <div data-epi-property="Answer" className="faq-content">
          {formattedAnswer}
        </div>
      </div>
    </div>
  )
}

export default PracticalFaqElement
